import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInput } from 'common/components/form';

import { handleOnBlurField } from '../../helpers';

const InterestRate = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'parameters_rate.value';
    return (
        <ReactHookFormIntlNumberInput
            append="%"
            control={control}
            disabled={disabled}
            fullWidth
            label={t('Interest rate')}
            name={name}
            onBlur={({ value }) => handleOnBlurField({ name, setValue, value })}
        />
    );
};

InterestRate.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default InterestRate;
